"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dealerList = _interopRequireDefault(require("../../styles/dealer-list.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var ListToggle = function ListToggle(_ref) {
  var theme = _ref.theme,
    mobileShowMap = _ref.mobileShowMap,
    updateMobileShowMap = _ref.updateMobileShowMap,
    listLabel = _ref.listLabel,
    mapLabel = _ref.mapLabel;
  if (!(0, _checkProps["default"])(mobileShowMap)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _dealerList["default"].listToggleButtons
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: theme.inputsAndOptions + " " + _dealerList["default"].toggleDefault + " " + (!mobileShowMap ? _dealerList["default"].toggleSelected : ''),
      onClick: function onClick() {
        return updateMobileShowMap(false);
      }
    }, listLabel), /*#__PURE__*/_react["default"].createElement("button", {
      className: theme.inputsAndOptions + " " + _dealerList["default"].toggleDefault + " " + (!mobileShowMap ? '' : _dealerList["default"].toggleSelected),
      onClick: function onClick() {
        return updateMobileShowMap(true);
      }
    }, mapLabel));
  }
  return null;
};
var _default = ListToggle;
exports["default"] = _default;